import { render, staticRenderFns } from "./TakePictureLogBook.vue?vue&type=template&id=ed464868&scoped=true&"
import script from "./TakePictureLogBook.vue?vue&type=script&lang=js&"
export * from "./TakePictureLogBook.vue?vue&type=script&lang=js&"
import style0 from "./TakePictureLogBook.vue?vue&type=style&index=0&id=ed464868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed464868",
  null
  
)

export default component.exports